export enum TextSeparator {
  Dash = "—",
  Dot = "•",
}
